"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyReset = void 0;
const styled_components_1 = require("styled-components");
exports.typographyReset = (0, styled_components_1.css) `
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
`;
//# sourceMappingURL=typographyReset.js.map